import React from 'react';
import './index.css'

function Resume() {
    return (
        <div>
            <a href="/resume.pdf">
                Suzanna's Resume
            </a>
            <h3>
                Proficient In:
                </h3>
            <ul>
                <li>
                    Responsive Design
                    </li>
                <li>
                    AJAX
                    </li>
                <li>
                    Node
                    </li>
                <li>
                    MongoDB
                    </li>
                <li>
                    JSON
                    </li>
                <li>
                    OOP
                    </li>
                <li>
                    DOM
                    </li>
                <li>
                    Express
                    </li>
                <li>
                    MySQL
                    </li>
                <li>
                    MVC Paradigm
                    </li>
                <li>
                    Sequelize
                    </li>
                <li>
                    Testing
                    </li>
                <li>
                    Agile Development
                    </li>
                <li>
                    Modularization
                    </li>
                <li>
                    HTML
                     </li>
                <li>
                    CSS
                    </li>
                <li>
                    JavaScript
                    </li>
                <li>
                    jQuery
                    </li>
                <li>
                    Bootstrap
                    </li>
                <li>
                    ES6
                    </li>
            </ul>
        </div>

    )
}

export default Resume;